function isRedStatus(disposition) {
    const redStatuses = [
      'AbandonedInQueue',
      'QueuingTimeout',
      'QueuingOverflow',
      'IVRException',
      'AbandonedInIVR'
    ];
    return redStatuses.includes(disposition);
}
function HATPYE(type) {
    let mapList = {
        "HA02": '烟感温度红外三合一报警器',
        "HA03": '门磁感应器',
        "HA04": '燃气报警器',
        "HA05": '红外体感探测器',
        "HA06": '水浸报警器',
        "HA07": '一键呼叫按钮',
        "HA08": '烟雾报警器',
        "HA09": '一氧化碳报警器',
        "HA10": '温湿度传感器',
        "HA11": '毫米波雷达',
        "HA11_PRO": '毫米波雷达',
        "": '--'
    }
    return mapList[type] || ''
}

function STTPYE(type) {
    // 定义一个数组，包含所有智能手表的类型
    if(['X1','X3','X5','X7','X8','M1','M3','S5','S1'].some(prefix => type.includes(prefix))){
        return '智能手表'
    }
    // 智能定位卡：包含 C3 前缀
    else if(['C3'].some(prefix => type.includes(prefix))){
        return '智能定位卡'
    }
    // 智能呼叫主机：包含 HA07 前缀
    else if(['HA07'].some(prefix => type.includes(prefix))){
        return '智能呼叫主机'
    }else{
        return type
    }
}

function codePYE(type) {
    let text = '预警提醒'
    let mapList = {
        2901: '无人' + text,
    }
    return mapList[type] || ''
}
function isValidIDCard(idCard) {
    // 身份证正则表达式
    // 格式验证：使用正则表达式验证身份证号码的格式
    if (!idCard || typeof idCard !== "string") {
        return false;
    }

    idCard = idCard.trim();

    const regExp = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
    if (!regExp.test(idCard)) {
        return false;
    }

    const year = parseInt(idCard.substr(6, 4), 10);
    const month = parseInt(idCard.substr(10, 2), 10);
    const day = parseInt(idCard.substr(12, 2), 10);

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const minYear = 1850;
    const maxYear = currentYear;

    if (year < minYear || year > maxYear) {
        return false;
    }

    if (month < 1 || month > 12) {
        return false;
    }

    const daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        daysInMonth[2] = 29;
    }

    if (day < 1 || day > daysInMonth[month]) {
        return false;
    }

    if (idCard.length === 18) {
        const weightedFactors = [
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2,
        ];
        const checkCodes = "10X98765432";
        let sum = 0;
        for (let i = 0; i < 17; i++) {
            sum += parseInt(idCard.charAt(i), 10) * weightedFactors[i];
        }
        const remainder = sum % 11;
        const lastChar = idCard.charAt(17).toUpperCase();
        if (lastChar !== checkCodes.charAt(remainder)) {
            return false;
        }
    }

    return true;
}

export default {
    HATPYE,
    codePYE,
    isValidIDCard,
    STTPYE,
    isRedStatus
}


// WEBPACK FOOTER //
// ./src/libs/utils.js